import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Table = lazyImport(() => import('@mui/material/Table'))
export const TableHead = lazyImport(() => import('@mui/material/TableHead'))
export const TableCell = lazyImport(() => import('@mui/material/TableCell'))
export const TableRow = lazyImport(() => import('@mui/material/TableRow'))
export const TablePagination = lazyImport(() => import('@mui/material/TablePagination'))
export const TableFooter = lazyImport(() => import('@mui/material/TableFooter'))
export const TableSortLabel = lazyImport(() => import('@mui/material/TableSortLabel'))